import { useCallback, useContext } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import core from '@gin-betting/core';
import filters from '@gin-betting/filters';

import { useAppliedFilters } from 'hooks';
import globalMessages from 'messages';
import { OverlayType } from '../../../constants';
import { MobileFiltersCtx } from '../MobileFiltersCtx';

interface Output {
    count: number;
    closeOverlay: VoidFunction;
    sportId: string | undefined;
    currentOverlay: OverlayType;
    allGameMsg: string;
    isClassicSport: boolean;
}

const {
    utils: { getSportTypeFromLocation },
    constants: { SportType },
} = core;

const {
    selectors: { selectCategorizerData },
} = filters;

function useFilterBySportHeading(): Output {
    const { formatMessage } = useIntl();
    const { setOverlay, currentOverlay } = useContext(MobileFiltersCtx);
    const categorizerData = useSelector(selectCategorizerData);

    const count = categorizerData.reduce((acc, item) => acc + item.count, 0);
    const closeOverlay = useCallback(() => {
        setOverlay(OverlayType.NONE);
    }, [setOverlay]);

    const { sportId } = useAppliedFilters();
    const isClassicSport = getSportTypeFromLocation() === SportType.Classic;

    return {
        count,
        sportId,
        closeOverlay,
        currentOverlay,
        allGameMsg: formatMessage(globalMessages.allGames),
        isClassicSport,
    };
}

export default useFilterBySportHeading;
